<template>
  <div>
    <div class="tag" @click="clickHandler" :class="{ 'tag--active': tag.active }" v-html="tag.name">
      <div class="tag__icon"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "tag",
  props: {
    tag: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions("groups", ["turnTag"]),
    clickHandler() {
      this.turnTag(this.tag);
    }
  }
};
</script>

<style lang="scss" scoped>
.tag {
  $color: #9b9b9b;
  font-size: 1.8rem;
  font-weight: 600;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 5.8rem;

  cursor: pointer;
  transition: background-color 0.3s;
  text-transform: uppercase;

  color: $color;
  border: 1px solid $color;
  border-radius: 30px;
  background: transparent;

  $root: &;
  &::selection {
    color: inherit;
    background: transparent;
  }
  &--active {
    color: $color;
    border-color: #f5f5f5;
    background: #f5f5f5;
  }
  &__icon {
    position: absolute;
    right: 1.3rem;

    width: 1.4rem;
    height: 100%;

    transition: transform 0.3s;

    background-image: url("../assets/icons/tag-icon.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 1.4rem;
    #{$root}--active & {
      transform: rotate(45deg);
    }
  }
}
</style>
